<script>
  // Navy header band shared by the gift pages (Gift Cards, Redeem a Gift) so
  // they read as one section of the site. Extra content, like a "how it
  // works" list, can be passed in the default slot.
  export let title
  export let intro = ''
</script>

<style type="text/less">
  .gift-header {
    background-color: var(--col-accent-2);
    color: var(--col-gray-100);
    text-align: center;
    padding: var(--spacing-lg) var(--spacing) calc(var(--spacing) * 2);
    font-size: 1.125rem;
    line-height: 1.6;

    > .icon {
      width: 3rem;
      height: 3rem;
      color: var(--col-accent-1);
    }

    h1 {
      font-size: 48px;
      font-weight: 500;
      letter-spacing: 2px;
      line-height: 1.2;
      margin: var(--spacing-xs) 0 var(--spacing-sm);
      color: var(--col-gray-100);
    }

    p {
      max-width: 620px;
      margin: 0 auto var(--spacing);

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: 1150px) {
    .gift-header h1 {
      font-size: 38px;
    }
  }
</style>

<section class="gift-header">
  <svg class="icon"><use href="/icons.svg#gift" /></svg>
  <h1>{title}</h1>
  {#if intro}<p>{intro}</p>{/if}
  <slot />
</section>
